module.exports = __webpack_public_path__ + "static/SLFCspread-9-e91c586f756bacea830c86d1ede0b24c.jpg";